import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { RoleEnum } from "../enums";
import { UserProfileDto } from "../interfaces";
import { SelectListDto } from "../models";
import { useGetUserProfileQuery } from "../store/api/accountApi";

export const Navdata = () => {
  //#region hooks

  const history = useHistory();

  const { data: profile } = useGetUserProfileQuery();

  //#endregion

  //#region

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isSubjects, setIsSubjects] = useState(false);
  const [isEducationSystem, setIsEducationSystem] = useState(false);
  const [isControl, setIsControl] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("dashboard");
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevelCp, setIsLevelCp] = useState(false);
  const [isNotifications, setIsNotifications] = useState(false);
  const [isComplaints, setIsComplaints] = useState(false);
  const [isReports, setIsReports] = useState(false);
  const [isMonitoring, setIsMonitoring] = useState<boolean>(false);
  const [isCategories, setIsCategories] = useState<boolean>(false);
  const [isContacts, setIsContacts] = useState<boolean>(false);
  const [isFileManager, setIsFileManager] = useState<boolean>(false);
  const [isAcademicCalendar, setIsAcademicCalendar] = useState<boolean>(false);
  const [isLiveLectures, setIsLiveLectures] = useState<boolean>(false);
  const [isReviews, setIsReviews] = useState<boolean>(false);

  //#endregion

  //#region redux state

  //#endregion

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id)?.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "subjects") {
      setIsSubjects(false);
    }
    // if (iscurrentState !== "areas") {
    //   setIsArea(false);
    // }
    // if (iscurrentState !== "olympiad") {
    //   setIsOlympiad(false);
    // }
    if (iscurrentState !== "educationSystem") {
      setIsEducationSystem(false);
    }
    if (iscurrentState !== "payment") {
      setIsPayment(false);
    }
    if (iscurrentState !== "notifications") {
      setIsNotifications(false);
    }
    if (iscurrentState !== "complaints") {
      setIsComplaints(false);
    }
    if (iscurrentState !== "reports") {
      setIsReports(false);
    }
    if (iscurrentState !== "monitoring") {
      setIsMonitoring(false);
    }
    if (iscurrentState !== "contacts") {
      setIsContacts(false);
    }
    if (iscurrentState !== "categories") {
      setIsCategories(false);
    }
    if (iscurrentState !== "file_manager") {
      setIsFileManager(false);
    }
    if (iscurrentState !== "academic_calendar") {
      setIsAcademicCalendar(false);
    }
    if (iscurrentState !== "live_lectures") {
      setIsLiveLectures(false);
    }
    if (iscurrentState !== "reviews") {
      setIsReviews(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isUsers,
    isSubjects,
    isEducationSystem,
    isNotifications,
    isComplaints,
    isReports,
    isMonitoring,
    isContacts,
    isCategories,
    isFileManager,
    isAcademicCalendar,
    isLiveLectures,
    isReviews,
  ]);

  const superAdminMenuItems: any = () => [
    {
      label: "menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "dashboard",
      icon: "ri-apps-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "educationSystem",
      label: "educationSystem",
      icon: "bx bxs-school",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsEducationSystem(!isEducationSystem);
        setIscurrentState("educationSystem");
        updateIconSidebar(e);
      },
      stateVariables: isEducationSystem,
      subItems: [
        {
          id: "educationSystems",
          label: "educationSystems",
          link: "/education-system/systems",
          parentId: "educationSystem",
        },
        {
          id: "curricula",
          label: "curricula",
          link: "/education-system/curricula",
          parentId: "educationSystem",
        },
        {
          id: "educationalStages",
          label: "educationalStages",
          link: "/education-system/educational-stages",
          parentId: "educationSystem",
        },
      ],
    },
    {
      id: "subjects",
      label: "subjects",
      icon: "ri-book-2-fill",
      link: "/subjects",
    },
    {
      id: "users",
      label: "users",
      icon: "ri-user-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "cp",
          label: "cpUsers",
          link: "/#",
          isChildItem: true,
          click: function (e: any) {
            e.preventDefault();
            setIsLevelCp(!isLevelCp);
          },
          stateVariables: isLevelCp,
          childItems: [
            {
              id: 1,
              label: "admins",
              link: "/users/cp-users/admins",
            },
            {
              id: 2,
              label: "systemAdmins",
              link: "/users/cp-users/system-admins",
            },
            {
              id: 3,
              label: "headTeacherAdmins",
              link: "/users/cp-users/head-teachers",
            },
            {
              id: 4,
              label: "teacherAdmins",
              link: "/users/cp-users/teacher-admins",
            },
          ],
        },
        {
          id: "appUsers",
          label: "appUsers",
          link: "/#",
          isChildItem: true,
          click: function (e: any) {
            e.preventDefault();
            setIsLevel1(!isLevel1);
          },
          stateVariables: isLevel1,
          childItems: [
            { id: 1, label: "students", link: "/users/app-users/students" },
            { id: 2, label: "parents", link: "/users/app-users/parents" },
            { id: 3, label: "teachers", link: "/users/app-users/teachers" },
          ],
        },
        {
          id: "testers",
          label: "testers",
          link: "/users/testers",
          parentId: "users",
        },
      ],
    },
    {
      id: "liveLectures",
      label: "liveLectures",
      icon: "ri-live-line",
      link: "/live-lectures",
      stateVariables: isLiveLectures,
      click: function (e: any) {
        e.preventDefault();
        setIsLiveLectures(!isLiveLectures);
        setIscurrentState("live_lectures");
        updateIconSidebar(e);
      },
    },
    {
      id: "meetings",
      label: "meetings",
      icon: "ri-vidicon-line",
      link: "/meetings",
    },
    {
      id: "academicCalendar",
      label: "academicCalendar",
      icon: "ri-calendar-line",
      link: "/academic-calendar",
      stateVariables: isAcademicCalendar,
      click: function (e: any) {
        e.preventDefault();
        setIsAcademicCalendar(!isAcademicCalendar);
        setIscurrentState("academic_calendar");
        updateIconSidebar(e);
      },
    },
    {
      id: "payment",
      label: "payment",
      icon: "ri-wallet-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment");
        updateIconSidebar(e);
      },
      stateVariables: isPayment,
      subItems: [
        {
          id: "transactionHistory",
          label: "transactionHistory",
          link: "/payment/transaction-history",
          parentId: "payment",
        },
        {
          id: "promoCode",
          label: "promoCodes",
          link: "/payment/promo-codes",
          parentId: "payment",
        },
        {
          id: "plans",
          label: "plans",
          link: "/payment/plans",
          parentId: "payment",
        },
      ],
    },
    {
      id: "notifications",
      label: "notifications",
      icon: "ri-notification-2-fill",
      link: "/#",
      stateVariables: isNotifications,
      click: function (e: any) {
        e.preventDefault();
        setIsNotifications(!isNotifications);
        setIscurrentState("notifications");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "notify",
          label: "notify",
          link: "/notifications/notify",
          parentId: "notifications",
        },
        {
          id: "list",
          label: "list",
          link: "/notifications/list",
          parentId: "notifications",
        },
      ],
    },
    {
      id: "reviews",
      label: "reviews",
      icon: "ri-star-line",
      link: "/#",
      stateVariables: isReviews,
      click: function (e: any) {
        e.preventDefault();
        setIsReviews(!isReviews);
        setIscurrentState("reviews");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "commentReviews",
          label: "commentReviews",
          link: "/reviews/comment-reviews",
          parentId: "reviews",
        },
      ],
    },
    {
      id: "complaints",
      label: "complaints",
      icon: "ri-feedback-fill",
      link: "/complaints",
      stateVariables: isComplaints,
      click: function (e: any) {
        e.preventDefault();
        setIsComplaints(!isComplaints);
        setIscurrentState("complaints");
        updateIconSidebar(e);
      },
    },
    {
      id: "reports",
      label: "reports",
      icon: "ri-file-chart-fill",
      link: "/reports",
      stateVariables: isReports,
      click: function (e: any) {
        e.preventDefault();
        setIsReports(!isReports);
        setIscurrentState("reports");
        updateIconSidebar(e);
      },
    },
    {
      id: "control",
      label: "controlApp",
      icon: "ri-equalizer-fill",
      link: "/#",
      stateVariables: isControl,
      click: function (e: any) {
        e.preventDefault();
        setIsControl(!isControl);
        setIscurrentState("control");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "content",
          label: "contentAndPrice",
          link: "/control-app",
          parentId: "control",
        },
        {
          id: "features",
          label: "features",
          link: "/control-app/features",
          parentId: "control",
        },
        {
          id: "settings",
          label: "enableDisable",
          link: "/control-app/enable-disable",
          parentId: "control",
        },
      ],
    },
    {
      id: "categories",
      label: "categories",
      icon: "ri-list-ordered",
      link: "/categories",
      stateVariables: isCategories,
      click: function (e: any) {
        e.preventDefault();
        setIsCategories(!isCategories);
        setIscurrentState("categories");
        updateIconSidebar(e);
      },
    },
    {
      id: "contacts",
      label: "contacts",
      icon: "ri-contacts-book-line",
      link: "/contacts",
      stateVariables: isContacts,
      click: function (e: any) {
        e.preventDefault();
        setIsContacts(!isContacts);
        setIscurrentState("contacts");
        updateIconSidebar(e);
      },
    },
    {
      id: "file_manager",
      label: "fileManager",
      icon: "ri-folders-line",
      link: "/file-manager",
      stateVariables: isFileManager,
      click: function (e: any) {
        e.preventDefault();
        setIsFileManager(!isFileManager);
        setIscurrentState("file_manager");
        updateIconSidebar(e);
      },
    },
    {
      id: "monitoring",
      label: "monitoring",
      icon: "ri-radar-line",
      link: "/#",
      stateVariables: isMonitoring,
      click: function (e: any) {
        e.preventDefault();
        setIsMonitoring(!isMonitoring);
        setIscurrentState("monitoring");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "logs",
          label: "logs",
          link: "/logs",
          parentId: "monitoring",
        },
        {
          id: "mediaConversionStatus",
          label: "mediaConversionStatus",
          link: "/monitoring/media-conversion-status",
          parentId: "monitoring",
        },
      ],
    },
  ];

  const teacherMenuItems: any = (courses: SelectListDto[]) => {
    const teacherMenu: any[] = [
      {
        label: "menu",
        isHeader: true,
      },
      {
        id: "dashboard",
        label: "dashboard",
        icon: "ri-apps-2-line",
        link: "/dashboard",
        stateVariables: isDashboard,
        click: function (e: any) {
          e.preventDefault();
          setIsDashboard(!isDashboard);
          setIscurrentState("dashboard");
          updateIconSidebar(e);
        },
      },
    ];

    if (courses && courses.length > 0) {
      teacherMenu.push({
        id: "subjects",
        label: "subjects",
        icon: "ri-book-2-fill",
        link: "/subjects",
      });
    }

    // Teaching delivery before settings
    teacherMenu.push({
      id: "liveLectures",
      label: "liveLectures",
      icon: "ri-live-line",
      link: "/live-lectures/live-lectures",
    });

    teacherMenu.push({
      id: "reviews",
      label: "reviews",
      icon: "ri-star-line",
      link: "/#",
      stateVariables: isReviews,
      click: function (e: any) {
        e.preventDefault();
        setIsReviews(!isReviews);
        setIscurrentState("reviews");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "commentReviews",
          label: "commentReviews",
          link: "/reviews/comment-reviews",
          parentId: "reviews",
        },
      ],
    });

    teacherMenu.push({
      id: "settings",
      label: "settings",
      icon: "ri-settings-3-line",
      link: "/settings",
    });

    return teacherMenu;
  };

  const adminMenuItems: any = (courses: SelectListDto[]) => {
    // Importance: Dashboard → Subjects → Live lectures → Users → Settings
    const menu = teacherMenuItems(courses);
    const settingsIndex = menu.findIndex((item: any) => item.id === "settings");
    const usersItem = {
      id: "users",
      label: "users",
      icon: "ri-account-circle-line",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "students",
          label: "students",
          link: "/users/app-users/students",
          parentId: "users",
        },
        {
          id: "parents",
          label: "parents",
          link: "/users/app-users/parents",
          parentId: "users",
        },
      ],
    };
    if (settingsIndex >= 0) {
      menu.splice(settingsIndex, 0, usersItem);
    } else {
      menu.push(usersItem);
    }
    return menu;
  };

  const othersMenuItems: any = [
    {
      label: "menu",
      isHeader: true,
    },
  ];

  const systemAdminMenuItems: any = () => {
    const denyIds = new Set([
      "educationSystem",
      "control",
      "complaints",
      "reports",
      "categories",
      "contacts",
      "file_manager",
      "monitoring",
      "meetings",
      "logs",
    ]);
    const denyPaymentSubIds = new Set(["promoCode", "plans"]);
    const denyCpUserLabels = new Set([
      "admins",
      "systemAdmins",
      "headTeacherAdmins",
      "teacherAdmins",
    ]);
    // Testers + feedback are Super Admin only (API + CP).
    const denyUserSubIds = new Set(["testers"]);

    return superAdminMenuItems()
      .filter((item: any) => !denyIds.has(item.id))
      .map((item: any) => {
        if (item.id === "payment") {
          return {
            ...item,
            subItems: (item.subItems || []).filter(
              (sub: any) => !denyPaymentSubIds.has(sub.id),
            ),
          };
        }
        if (item.id !== "users") return item;
        return {
          ...item,
          subItems: (item.subItems || [])
            .filter((sub: any) => !denyUserSubIds.has(sub.id))
            .map((sub: any) => {
              if (sub.id !== "cp") return sub;
              const childItems = (sub.childItems || []).filter(
                (child: any) => !denyCpUserLabels.has(child.label),
              );
              if (childItems.length === 0) return null;
              return {
                ...sub,
                childItems,
              };
            })
            .filter(Boolean),
        };
      });
  };

  const [_user, _setUser] = useState<UserProfileDto | null>(null);

  useEffect(() => {
    if (profile) {
      _setUser(profile);
    }
  }, [profile]);

  const renderMenu = () => {
    if (_user && _user.role && _user.role.key) {
      if (_user.role.key === RoleEnum.SUPER_ADMIN)
        return <React.Fragment>{superAdminMenuItems()}</React.Fragment>;
      if (_user.role.key === RoleEnum.SYSTEM_ADMIN)
        return <React.Fragment>{systemAdminMenuItems()}</React.Fragment>;
      if (_user.role.key === RoleEnum.ADMIN)
        return (
          <React.Fragment>{adminMenuItems(_user.courses || [])}</React.Fragment>
        );
      if (_user.role.key === RoleEnum.HEAD_TEACHER_ADMIN)
        return (
          <React.Fragment>
            {teacherMenuItems(_user.courses || [])}
          </React.Fragment>
        );
      if (_user.role.key === RoleEnum.TEACHER_ADMIN)
        return (
          <React.Fragment>
            {teacherMenuItems(_user.courses || [])}
          </React.Fragment>
        );
    }
    return <React.Fragment>{othersMenuItems}</React.Fragment>;
  };

  return renderMenu();
};

export default Navdata;
